export { default as Detail } from 'fixedassets/containers/AssetDetailContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/containers/index.js